/*
    This file is part of Universal Sequences.
    Universal Sequences is free software: you can redistribute it and/or modif
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Universal Sequences is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import React, { Component } from 'react';
import MidiEffectComponent from './MidiEffectComponent.js';
import LiveEffectComponent from './LiveEffectComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import OscilloscopeComponent from './OscilloscopeComponent.js';
import WetSlider from './WetSlider.js';
import Tone from 'tone';
import TrackSend from 'components/effects/TrackSend.js';
import { connect } from "react-redux";
import {
    SYNTH,
    MULTI_SYNTH,
    SAMPLED_INSTRUMENT,
    FM_SYNTH,
    METAL_SYNTH} from 'constants/instrument-types.js';
import {setSelectedEffect} from 'actions/index.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import LockButton from 'components/LockButton.js';
import Dropdown from 'react-dropdown';
import ParameterFuture from 'effects/ParameterFuture.js';
import TrackOutputType from 'components/track/TrackOutputType.js';
import ExternalInstrumentComponent from './ExternalInstrumentComponent.js';
import AddEffect from 'components/effects/AddEffect.js';
import DeletableEffectComponent from 'components/effects/DeletableEffectComponent.js';
import MultiSynthComponent from 'components/instruments/MultiSynthComponent.js';
import SampledInstrumentComponent from 'components/instruments/sampledInstrument/SampledInstrumentComponent.js';
import FMSynthComponent from 'components/instruments/FMSynthComponent.js';
import MetalSynthComponent from 'components/instruments/MetalSynthComponent.js';
import InstrumentComponent from './InstrumentComponent.js';
import GateEffect from './GateEffect.js';
import PanningComponent from './PanningComponent.js';
import FilterEffect from './FilterEffect.js';
import AutoFilterEffect from './AutoFilterEffect.js';
import ReverbEffect from './ReverbEffect.js';
import ConvolverReverbEffect from './ConvolverReverbEffect.js';
import ChorusEffect from './ChorusEffect.js';
import TremoloEffect from './TremoloEffect.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {getInstrumentComponent} from './getInstrumentComponent.js';
import InstrumentRackComponent from 'components/instruments/InstrumentRackComponent.js';
import DelayEffect from './DelayEffect.js';
import CompressorEffect from './CompressorEffect.js';
import ChebyshevEffect from './ChebyshevEffect.js';
import EQ3Effect from './EQ3Effect.js';
import EQ10Effect from './EQ10Effect.js';
import MultibandCompressorEffect from './MultibandCompressorEffect.js';
import UltraPhaserEffect from './UltraPhaserEffect.js';
import AutoWahEffect from './AutoWahEffect.js';
import DistortionEffect from './DistortionEffect.js';
import BitCrusherEffect from './BitCrusherEffect.js';
import SaturatorEffect from './SaturatorEffect.js';
import PitchShift from './PitchShift.js';
import PannerEffect from './PannerEffect.js';
import FrequencyAnalyserEffect from './FrequencyAnalyserEffect.js';
import StereoWidenerEffect from './StereoWidenerEffect.js';
import TapeDelayComponent from './TapeDelayComponent.js';
import StereoDelayComponent from './StereoDelayComponent.js';
import EffectRackComponent from './EffectRackComponent.js';
import {addEffect} from 'operations/actions.js';
import {setAccumulatorParameterSelected} from 'actions/index.js';

class EffectComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getEffect() {
    if (this.props.effect.name === 'Filter') {
        return (
            <FilterEffect
              {... this.props}
              effectNumber={this.props.effectNumber}
              sequencerEngine={this.props.sequencerEngine}
              automation={this.props.automation}
              selectedParameter={this.props.selectedParameter}
              onEffectsChange={this.props.onEffectsChange}
              onParameterChanged={this.props.onParameterChanged}
              filterEffect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Auto Filter') {
            return (
                <AutoFilterEffect
                    {... this.props}
                    track={this.track}
                    sequencerEngine={this.props.sequencerEngine}
                    effectNumber={this.props.effectNumber}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    filterEffect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Delay') {
            return (
                <DelayEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    delayEffect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Tremolo') {
            return (
                <TremoloEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    automation={this.props.automation}
                    sequencerEngine={this.props.sequencerEngine}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    tremoloEffect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Chorus') {
            return (
                <ChorusEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    automation={this.props.automation}
                    sequencerEngine={this.props.sequencerEngine}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    chorusEffect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Reverb') {
            return (
                <ReverbEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    automation={this.props.automation}
                    sequencerEngine={this.props.sequencerEngine}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    reverbEffect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Convolver Reverb') {
            return (
                <ConvolverReverbEffect
                  {... this.props}
                    effectNumber={this.props.effectNumber}
                    automation={this.props.automation}
                    sequencerEngine={this.props.sequencerEngine}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    reverbEffect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Compressor') {
            return (
                <CompressorEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    automation={this.props.automation}
                    sequencerEngine={this.props.sequencerEngine}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Distortion') {
            return (
                <DistortionEffect
                    {... this.props}
                    sequencerEngine={this.props.sequencerEngine}
                    effectNumber={this.props.effectNumber}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'EQ 3') {
            return (
                <EQ3Effect
                    {... this.props}
                    sequencerEngine={this.props.sequencerEngine}
                    effectNumber={this.props.effectNumber}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'EQ 10') {
            return (
                <EQ10Effect
                    {... this.props}
                    sequencerEngine={this.props.sequencerEngine}
                    effectNumber={this.props.effectNumber}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Bit Crusher') {
            return (
                <BitCrusherEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    automation={this.props.automation}
                    sequencerEngine={this.props.sequencerEngine}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Ultra Phaser') {
            return (
                <UltraPhaserEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    sequencerEngine={this.props.sequencerEngine}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Auto Wah') {
            return (
                <AutoWahEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    automation={this.props.automation}
                    sequencerEngine={this.props.sequencerEngine}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Gate') {
            return (
                <GateEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    tracks={this.props.tracks}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Pitch Shift') {
            return (
                <PitchShift
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    tracks={this.props.tracks}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Panner') {
            return (
                <PannerEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    tracks={this.props.tracks}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'EQ8') {
            return (
                <FrequencyAnalyserEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    tracks={this.props.tracks}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Chebyshev') {
            return (
                <ChebyshevEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    tracks={this.props.tracks}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Multiband Compressor') {
            return (
                <MultibandCompressorEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    tracks={this.props.tracks}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Stereo Widener') {
            return (
                <StereoWidenerEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    tracks={this.props.tracks}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Saturator') {
            return (
                <SaturatorEffect
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    tracks={this.props.tracks}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Tape Delay') {
            return (
                <TapeDelayComponent
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    tracks={this.props.tracks}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Stereo Delay') {
            return (
                <StereoDelayComponent
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    tracks={this.props.tracks}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Oscilloscope') {
            return (
                <OscilloscopeComponent
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    tracks={this.props.tracks}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else if (this.props.effect.name === 'Effect Rack') {
            return (
                <EffectRackComponent
                    {... this.props}
                    effectNumber={this.props.effectNumber}
                    tracks={this.props.tracks}
                    sequencerEngine={this.props.sequencerEngine}
                    automation={this.props.automation}
                    selectedParameter={this.props.selectedParameter}
                    onEffectsChange={this.props.onEffectsChange}
                    onParameterChanged={this.props.onParameterChanged}
                    effect={this.props.effect}/>
            );
        } else {
            return null;
        }
    }

    render() {
        return (
            <DeletableEffectComponent
              {... this.props}
              onDeleteEffect={this.props.onDeleteEffect}
              effectNumber={this.props.effectNumber}
              onToggle={() => this.setState(this.state)}
              track={this.props.track}
              group={this.props.group}
              send={this.props.send}
              effect={this.props.effect}
              automation={this.props.automation}>
              {this.getEffect()}
            </DeletableEffectComponent>
        );
    }
}

class EffectsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedParameter: undefined,
            effectsView: React.createRef()
        };

        this.unmapSelectedParameter = this.unmapSelectedParameter.bind(this);
    }

    unmapSelectedParameter() {
        console.log("UMMAP!");
        this.props.sequencerEngine.dispatch(setAccumulatorParameterSelected(undefined));
    }

    componentDidMount() {
        console.log("component did mount = ", this.state.effectsView);
        this.state.effectsView.current.addEventListener("scroll", this.unmapSelectedParameter);
    }

    componentWillUnmount() {
        this.state.effectsView.current.removeEventListener("scroll", this.unmapSelectedParameter);
        this.unmapSelectedParameter();
    }

    handleChooseMidiEffect(effect) {
        this.props.sequencerEngine.operationManager.dispatch(
            addEffect(effect, this.props.track, this.props.group, this.props.send));
        this.setState(this.state);
    }

    handleChooseLiveEffect(effect) {
        this.props.track.liveEffects.addEffect(effect);
        this.setState(this.state);
    }

    handleChooseEffect(effect) {
        effect.enable(true);
        this.props.sequencerEngine.operationManager.dispatch(
            addEffect(effect, this.props.track, this.props.group, this.props.send));
        this.setState(this.state);
    }

    onParameterChanged(p, effect) {
        if (this.props.track === undefined &&
            this.props.group === undefined &&
            this.props.send === undefined) {
            return;
        }
        this.props.setSelectedEffect(effect.id);
        this.props.onParameterChanged(p);
    }

    onDeleteEffect() {
        this.setState(this.state);
    }

    toggleLock() {
        this.props.track.togglePatternLock();
    }

    onChangePanning(panning) {
        if (this.props.track !== undefined) {
            this.props.track.setPanning(panning);
        } else if (this.props.group !== undefined) {
            this.props.group.setPanning(panning);
        }
    }

    render() {
        let effects = this.props.send !== undefined ? this.props.send.effects : 
            this.props.track !== undefined ?
            this.props.track.effects : this.props.group.effects;

        if (this.props.track) {
            effects = this.props.track.getEffects(this.props.chainNumber);
        }

        let sendNodes = this.props.send !== undefined ? this.props.send.getSendNodes() :
            this.props.track !== undefined ?
            this.props.track.getSendNodes() : this.props.group.getSendNodes();

        let midiEffects = this.props.track !== undefined ?
            this.props.track.midiEffects.effects : [];
        let liveEffects = this.props.track !== undefined ?
            this.props.track.liveEffects.effects : [];

        let instrument = getInstrumentComponent(
            this.props.track,
            this.props.scrollContainer || this.state.effectsView) || '';
        if (this.props.isFrozen) {
            instrument = '';
        }

        if (effects === undefined || liveEffects === undefined ||
            midiEffects === undefined) {
            return (
                <div></div>
            );
        }

        return (
            <div
              ref={this.state.effectsView}
              className="effects-view">
              {liveEffects.map(
                  (effect, i) =>
                      <LiveEffectComponent
                            key={"live-effect-" + i}
                        scrollContainer={this.props.scrollContainer ||
                                         this.state.effectsView}
                            sequencerEngine={this.props.sequencerEngine}
                            onDeleteEffect={() => this.onDeleteEffect()}
                            effect={effect}
                            selectedParameter={this.state.selectedParameter}
                            track={this.props.track}
                            tracks={this.props.tracks}
                            onParameterChanged={(p) => this.onParameterChanged(p, effect)}
                        onEffectsChange={this.props.onEffectsChange}/>)}
              {instrument}
              {midiEffects.map(
                  (effect, i) =>
                      <MidiEffectComponent
                  key={"midi-effect-"+i}
                            sequencerEngine={this.props.sequencerEngine}
                        scrollContainer={this.props.scrollContainer ||
                                         this.state.effectsView}
                            onDeleteEffect={() => this.onDeleteEffect()}
                            effect={effect}
                            isMixCollapsed={this.props.isMixCollapsed}
                            selectedParameter={this.state.selectedParameter}
                            track={this.props.track}
                            tracks={this.props.tracks}
                            onParameterChanged={(p) => this.onParameterChanged(p, effect)}
                        onEffectsChange={this.props.onEffectsChange}/>)}
              {effects.map(
                  (effect, i) =>
                      <EffectComponent
                            sequencerEngine={this.props.sequencerEngine}
                        scrollContainer={this.props.scrollContainer ||
                                         this.state.effectsView}
                            key={"effect-"+i}
                            onDeleteEffect={() => this.onDeleteEffect()}
                            effect={effect}
                            isMixCollapsed={this.props.isMixCollapsed}
                            selectedParameter={this.state.selectedParameter}
                            track={this.props.track}
                            group={this.props.group}
                            send={this.props.send}
                            tracks={this.props.tracks}
                            onParameterChanged={(p) => this.onParameterChanged(p, effect)}
                            onEffectsChange={this.props.onEffectsChange}/>)}
                <AddEffect
                  track={this.props.track}
                  sequencerEngine={this.props.sequencerEngine}
                  addClassName="add-track-effects-button"
                  handleChooseMidiEffect={(effect) => this.handleChooseMidiEffect(effect)} 
                  handleChooseLiveEffect={(effect) => this.handleChooseLiveEffect(effect)} 
                  handleChooseEffect={(effect) => this.handleChooseEffect(effect)}
                  store={this.props.store}/>
              <div className="sends-and-options-container">
                <div className="sends-container">
              {sendNodes.map((sendNode, i) =>
              <TrackSend
                key={"track-send-" + i}
                track={this.props.track}
                sequencerEngine={this.props.sequencerEngine}
                sendNumber={i}
                send={this.props.sends.getSends()[i]}
                sendNode={sendNode}/>)}
                <PanningComponent
                  panning={this.props.panning}
                  onChangePanning={(p) => this.onChangePanning(p)}/>
                </div>
                {this.props.track ? <TrackOutputType track={this.props.track}/> : ''}
              </div>
                <div className="effect-lock">
                <ConditionedComponent condition={!this.props.hideLock}>
                  <LockButton
                    patternLocked={this.props.patternLocked}
                    toggleLock={() => this.toggleLock()}/>
                </ConditionedComponent>
                </div>
           </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    let locked = false;
    let isFrozen = false;
    if (props.track !== undefined) {
        let subSequenceLocks = state.tracks.trackPatternLocks[props.track.subSequence.id] || {};
        let patterns = subSequenceLocks[props.track.trackNumber] || {};
        locked = patterns[props.track.currentPattern] || false;
        isFrozen = props.track.isFrozen;
    }
    let panning = 0;
    let chainNumber = undefined;
    if (props.track !== undefined) {
        panning = state.tracks.trackPannings[props.track.trackNumber] || 0;
        chainNumber = props.track.chainNumber;
    } else if (props.group !== undefined) {
        panning = state.tracks.groupPannings[props.group.groupNumber] || 0;
    }
    let element = props.track || props.group || props.send;
    return {
        isFrozen: isFrozen,
        patternLocked: locked,
        panning: panning,
        chainNumber: chainNumber,
        effects: element.effects,
        effectsLen: element.effects ? element.effects.length :
            element.midiEffects && element.midiEffects.effects ?
            element.midiEffects.effects.length : 0,
        midiEffects: element.midiEffects && element.midiEffects.effects,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setSelectedEffect: id => dispatch(setSelectedEffect(id)),
    }
};

const EffectComponents = {
    EffectsView: connect(mapStateToProps, mapDispatchToProps)(EffectsView),
    EffectComponent: EffectComponent,
};

export default EffectComponents;
